import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enTranslations from './locales/en.json';
import frTranslations from './locales/fr.json';
import { 
  detectCountryFromIP, 
  getLanguageFromCountry, 
  getSavedLanguage, 
  saveLanguageChoice 
} from '../utils/geolocation';



// Export resources for type safety
export const resources = {
  en: {
    translation: enTranslations
  },
  fr: {
    translation: frTranslations
  }
};

// Fonction pour initialiser la langue basée sur la géolocalisation
const initializeLanguageFromGeolocation = async () => {
  try {
    // 1. Vérifier d'abord si une langue est définie dans l'URL
    const urlLang = window.location.pathname.startsWith('/en') ? 'en' : null;
    if (urlLang) {
      await i18n.changeLanguage(urlLang);
      return;
    }
    
    // 2. Vérifier si l'utilisateur a déjà fait un choix manuel
    const savedLang = getSavedLanguage();
    if (savedLang) {
      await i18n.changeLanguage(savedLang);
      return;
    }
    
    // 3. Détection automatique basée sur l'IP pour les nouveaux visiteurs
    console.info('Détection automatique de la langue basée sur la géolocalisation...');
    const countryCode = await detectCountryFromIP();
    const detectedLanguage = getLanguageFromCountry(countryCode);
    
    // Sauvegarder le choix automatique
    saveLanguageChoice(detectedLanguage as 'fr' | 'en');
    await i18n.changeLanguage(detectedLanguage);
    
    console.info(`Langue détectée automatiquement: ${detectedLanguage} (pays: ${countryCode})`);
    
  } catch (error) {
    console.warn('Erreur lors de la détection de langue:', error);
    await i18n.changeLanguage('fr'); // Fallback par défaut
  }
};

// Initialize i18next
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'fr',
    debug: process.env.NODE_ENV === 'development',
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['path', 'localStorage', 'navigator'],
      lookupFromPathIndex: 0
    }
  });

// Initialiser la détection de langue après le chargement
if (typeof window !== 'undefined') {
  // Délai pour permettre au DOM de se charger complètement
  setTimeout(() => {
    initializeLanguageFromGeolocation();
  }, 100);
}

export default i18n; 